// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Json = require("@glennsl/bs-json/lib/js/src/Json.bs.js");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Js_exn = require("bs-platform/lib/js/js_exn.js");
var Printf = require("bs-platform/lib/js/printf.js");
var Network = require("./network");
var Pervasives = require("bs-platform/lib/js/pervasives.js");
var Caml_format = require("bs-platform/lib/js/caml_format.js");
var Json_decode = require("@glennsl/bs-json/lib/js/src/Json_decode.bs.js");
var Json_encode = require("@glennsl/bs-json/lib/js/src/Json_encode.bs.js");
var Js_primitive = require("bs-platform/lib/js/js_primitive.js");
var Caml_builtin_exceptions = require("bs-platform/lib/js/caml_builtin_exceptions.js");

function jsonParse(vals) {
  try {
    return JSON.parse(vals);
  }
  catch (exn){
    return Pervasives.failwith("Error parsing JSON string");
  }
}

function decodedTokenData(json) {
  var a = Json_decode.field("expires_in", Json_decode.$$int, json);
  var b = Json_decode.field("access_token", Json_decode.string, json);
  var c = Json_decode.field("refresh_token", Json_decode.string, json);
  return /* record */[
          /* expiry */a,
          /* accessToken */b,
          /* refreshToken */c
        ];
}

function setAccessTokenandExpiry(tokenData) {
  localStorage.setItem("access_token", tokenData[/* accessToken */1]);
  localStorage.setItem("refresh_token", tokenData[/* refreshToken */2]);
  localStorage.setItem("token_timestamp", Curry._1(Printf.sprintf(/* Format */[
                /* Float */Block.__(8, [
                    /* Float_f */0,
                    /* No_padding */0,
                    /* Lit_precision */[1],
                    /* End_of_format */0
                  ]),
                "%.1f"
              ]), Date.now()));
  localStorage.setItem("token_expires_at", Curry._1(Printf.sprintf(/* Format */[
                /* Float */Block.__(8, [
                    /* Float_f */0,
                    /* No_padding */0,
                    /* Lit_precision */[1],
                    /* End_of_format */0
                  ]),
                "%.1f"
              ]), Date.now() + 1000.0 * 60.0 * 60.0 * 24.0 * 365.0));
  return tokenData;
}

function checkDate(jsonVal) {
  var expDate;
  var exit = 0;
  var floatNum;
  try {
    floatNum = Json_decode.$$float(jsonVal);
    exit = 1;
  }
  catch (raw_exn){
    var exn = Js_exn.internalToOCamlException(raw_exn);
    if (exn[0] === Caml_builtin_exceptions.failure) {
      console.log("expiry parsing issue: ", exn[1]);
      expDate = /* None */0;
    } else {
      throw exn;
    }
  }
  if (exit === 1) {
    expDate = /* Some */[floatNum];
  }
  var actualDate = Date.now();
  if (expDate) {
    var match = +(expDate[0] - actualDate > 0.0);
    if (match !== 0) {
      return /* true */1;
    } else {
      return /* false */0;
    }
  } else {
    return /* false */0;
  }
}

function localStorageSupported() {
  var exit = 0;
  var val;
  try {
    val = Js_primitive.null_to_opt(localStorage.getItem("someentry"));
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    console.log("localStorage issue in support testing", x);
    return /* false */0;
  }
  if (exit === 1) {
    if (val) {
      try {
        return /* true */1;
      }
      catch (raw_exn){
        var exn = Js_exn.internalToOCamlException(raw_exn);
        if (exn[0] === Caml_builtin_exceptions.failure) {
          console.log("ls testing exception: ", exn[1]);
          return /* true */1;
        } else {
          throw exn;
        }
      }
    } else {
      return /* true */1;
    }
  }
  
}

function checkIfLoggedIn() {
  var exit = 0;
  var val;
  try {
    val = Js_primitive.null_to_opt(localStorage.getItem("token_expires_at"));
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    console.log("localStorage issue", x);
    return /* false */0;
  }
  if (exit === 1) {
    if (val) {
      var exit$1 = 0;
      var val$1;
      try {
        val$1 = /* Some */[jsonParse(val[0])];
        exit$1 = 2;
      }
      catch (raw_exn){
        var exn = Js_exn.internalToOCamlException(raw_exn);
        if (exn[0] === Caml_builtin_exceptions.failure) {
          console.log("logged in checking exception: ", exn[1]);
          return /* false */0;
        } else {
          throw exn;
        }
      }
      if (exit$1 === 2) {
        if (val$1) {
          return checkDate(val$1[0]);
        } else {
          return /* false */0;
        }
      }
      
    } else {
      return /* false */0;
    }
  }
  
}

function storeLoc(a, b, c, d, e) {
  console.log("store workout route", /* tuple */[
        a,
        b,
        c,
        d,
        e
      ]);
  var locRes = Json.stringify(/* array */[
        a,
        b,
        c,
        d,
        e
      ]);
  localStorage.setItem("loc", locRes);
  return /* () */0;
}

function clearLoc() {
  localStorage.removeItem("loc");
  return /* () */0;
}

function checkLoc(jsonVal) {
  var exit = 0;
  var returnArray;
  try {
    returnArray = Json_decode.array(Json_decode.string, jsonVal);
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    if (x[0] === Caml_builtin_exceptions.failure) {
      console.log("loc parsing issue: ", x[1]);
      return /* None */0;
    } else {
      console.log("loc parsing issue exception x", x);
      return /* None */0;
    }
  }
  if (exit === 1) {
    return /* Some */[returnArray];
  }
  
}

function readLocFromLs() {
  var exit = 0;
  var val;
  try {
    val = Js_primitive.null_to_opt(localStorage.getItem("loc"));
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    console.log("localStorage issue", x);
    return /* None */0;
  }
  if (exit === 1) {
    if (val) {
      var exit$1 = 0;
      var val$1;
      try {
        val$1 = /* Some */[jsonParse(val[0])];
        exit$1 = 2;
      }
      catch (raw_exn){
        var exn = Js_exn.internalToOCamlException(raw_exn);
        if (exn[0] === Caml_builtin_exceptions.failure) {
          console.log("loc checking exception: ", exn[1]);
          return /* None */0;
        } else {
          throw exn;
        }
      }
      if (exit$1 === 2) {
        if (val$1) {
          return checkLoc(val$1[0]);
        } else {
          return /* None */0;
        }
      }
      
    } else {
      return /* None */0;
    }
  }
  
}

function checkForLastRouteFromLs() {
  var match = readLocFromLs(/* () */0);
  if (match) {
    return match[0];
  } else {
    return /* array */[""];
  }
}

function calculateProgramDay() {
  var start_date_timestamp;
  var exit = 0;
  var val;
  try {
    val = Js_primitive.null_to_opt(localStorage.getItem("start_date_timestamp"));
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    console.log("localStorage issue", x);
    start_date_timestamp = 0.0;
  }
  if (exit === 1) {
    if (val) {
      try {
        start_date_timestamp = Caml_format.caml_float_of_string(val[0]);
      }
      catch (exn){
        console.log("issue with startDate conversion to float");
        start_date_timestamp = 1.0;
      }
    } else {
      start_date_timestamp = 0.0;
    }
  }
  if (start_date_timestamp > 2.0) {
    var tStart = new Date(start_date_timestamp);
    var dateHours = tStart.getHours();
    var dateMinutes = tStart.getMinutes();
    var diffH = 1000.0 * 60.0 * 60.0 * dateHours;
    var diffM = 1000.0 * 60.0 * dateMinutes;
    var adjustedStartDate = start_date_timestamp - diffH - diffM;
    var now = Date.now();
    var diff = now - adjustedStartDate;
    return diff / 1000.0 / 60.0 / 60.0 / 24.0 | 0;
  } else {
    return -1;
  }
}

function weekOfDay() {
  return (calculateProgramDay(/* () */0) / 7 | 0) + 1 | 0;
}

function weekDay() {
  return calculateProgramDay(/* () */0) % 7 + 1 | 0;
}

function fullDay() {
  return calculateProgramDay(/* () */0) + 1 | 0;
}

function fullDayMax28() {
  var res = calculateProgramDay(/* () */0) + 1 | 0;
  if (res > 28) {
    return 28;
  } else {
    return res;
  }
}

function getWeight() {
  var match = localStorage.getItem("wizard_result");
  if (match !== null) {
    var exit = 0;
    var x;
    try {
      x = /* Some */[jsonParse(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("getWeight exception", exn[1]);
        return 0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (x) {
        return Network.readWizardResultFromLs(x[0])[/* weight */0];
      } else {
        return 0;
      }
    }
    
  } else {
    return 0;
  }
}

function getDuration() {
  var match = localStorage.getItem("wizard_result");
  if (match !== null) {
    var exit = 0;
    var x;
    try {
      x = /* Some */[jsonParse(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("getDuration exception", exn[1]);
        return 0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (x) {
        return Network.readWizardResultFromLs(x[0])[/* duration */2];
      } else {
        return 0;
      }
    }
    
  } else {
    return 0;
  }
}

function getCals() {
  var match = localStorage.getItem("wizard_result");
  if (match !== null) {
    var exit = 0;
    var x;
    try {
      x = /* Some */[jsonParse(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("getDuration exception", exn[1]);
        return 0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (x) {
        var match$1 = Network.readWizardResultFromLs(x[0])[/* cals */1];
        if (match$1 !== 1100) {
          if (match$1 !== 1300) {
            if (match$1 !== 1500) {
              return 0;
            } else {
              return 1500;
            }
          } else {
            return 1300;
          }
        } else {
          return 1100;
        }
      } else {
        return 0;
      }
    }
    
  } else {
    return 0;
  }
}

function getCalsLevel() {
  var match = localStorage.getItem("wizard_result");
  if (match !== null) {
    var exit = 0;
    var x;
    try {
      x = /* Some */[jsonParse(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("getDuration exception", exn[1]);
        return 0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (x) {
        var match$1 = Network.readWizardResultFromLs(x[0])[/* cals */1];
        if (match$1 !== 1100) {
          if (match$1 !== 1300 && match$1 === 1500) {
            return 1;
          } else {
            return 0;
          }
        } else {
          return 2;
        }
      } else {
        return 0;
      }
    }
    
  } else {
    return 0;
  }
}

function store14() {
  console.log("set read14 to true", /* () */0);
  var doneRes = Json.stringify(Json_encode.bool(/* true */1));
  localStorage.setItem("read14", doneRes);
  return /* () */0;
}

function clear14() {
  localStorage.removeItem("read14");
  return /* () */0;
}

function check14(jsonVal) {
  var checkBool;
  try {
    checkBool = Json_decode.bool(jsonVal);
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    if (x[0] === Caml_builtin_exceptions.failure) {
      console.log("14 parsing issue: ", x[1]);
      checkBool = /* false */0;
    } else {
      console.log("14 parsing issue exception x", x);
      checkBool = /* false */0;
    }
  }
  console.log("checkbool", checkBool);
  return checkBool;
}

function show14() {
  var nextStepNeeded = +((calculateProgramDay(/* () */0) + 1 | 0) === 14 || (calculateProgramDay(/* () */0) + 1 | 0) === 15 || (calculateProgramDay(/* () */0) + 1 | 0) === 16);
  var calsCorrect = +(getCals(/* () */0) === 1300);
  var match = localStorage.getItem("read14");
  var lsVal;
  if (match !== null) {
    var exit = 0;
    var val;
    try {
      val = /* Some */[jsonParse(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("14 checking exception: ", exn[1]);
        lsVal = /* false */0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      lsVal = val ? check14(val[0]) : /* false */0;
    }
    
  } else {
    lsVal = /* false */0;
  }
  var match$1 = nextStepNeeded && 1 - lsVal && calsCorrect;
  if (match$1 !== 0) {
    return /* true */1;
  } else {
    return /* false */0;
  }
}

function store24() {
  console.log("set read24 to true", /* () */0);
  var doneRes = Json.stringify(Json_encode.bool(/* true */1));
  localStorage.setItem("read24", doneRes);
  return /* () */0;
}

function clear24() {
  localStorage.removeItem("read24");
  return /* () */0;
}

function check24(jsonVal) {
  var checkBool;
  try {
    checkBool = Json_decode.bool(jsonVal);
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    if (x[0] === Caml_builtin_exceptions.failure) {
      console.log("24 parsing issue: ", x[1]);
      checkBool = /* false */0;
    } else {
      console.log("24 parsing issue exception x", x);
      checkBool = /* false */0;
    }
  }
  console.log("checkbool", checkBool);
  return checkBool;
}

function show24() {
  var nextStepNeeded = +((calculateProgramDay(/* () */0) + 1 | 0) === 24 || (calculateProgramDay(/* () */0) + 1 | 0) === 25 || (calculateProgramDay(/* () */0) + 1 | 0) === 26);
  var calsCorrect = +(getCals(/* () */0) === 1500);
  var match = localStorage.getItem("read24");
  var lsVal;
  if (match !== null) {
    var exit = 0;
    var val;
    try {
      val = /* Some */[jsonParse(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("24 checking exception: ", exn[1]);
        lsVal = /* false */0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      lsVal = val ? check24(val[0]) : /* false */0;
    }
    
  } else {
    lsVal = /* false */0;
  }
  var match$1 = nextStepNeeded && 1 - lsVal && calsCorrect;
  if (match$1 !== 0) {
    return /* true */1;
  } else {
    return /* false */0;
  }
}

function storeWeightDiff(number) {
  console.log("set weightDiff to number", number);
  var newWeight = Json.stringify(number);
  localStorage.setItem("weight_diff", newWeight);
  return /* () */0;
}

function clearNewWeight() {
  localStorage.removeItem("weight_diff");
  return /* () */0;
}

function checkNewWeight(jsonVal) {
  var checkInt;
  var exit = 0;
  var returnVal;
  try {
    returnVal = Json_decode.$$int(jsonVal);
    exit = 1;
  }
  catch (raw_x){
    var x = Js_exn.internalToOCamlException(raw_x);
    if (x[0] === Caml_builtin_exceptions.failure) {
      console.log("int weight parsing issue: ", x[1]);
      checkInt = /* None */0;
    } else {
      console.log("int weight parsing issue exception x", x);
      checkInt = /* None */0;
    }
  }
  if (exit === 1) {
    checkInt = /* Some */[returnVal];
  }
  console.log("checkInt", checkInt);
  return checkInt;
}

function getWeightDiff() {
  var match = localStorage.getItem("weight_diff");
  if (match !== null) {
    var exit = 0;
    var val;
    try {
      val = /* Some */[jsonParse(match)];
      exit = 1;
    }
    catch (raw_exn){
      var exn = Js_exn.internalToOCamlException(raw_exn);
      if (exn[0] === Caml_builtin_exceptions.failure) {
        console.log("weight_diff checking exception: ", exn[1]);
        return /* None */0;
      } else {
        throw exn;
      }
    }
    if (exit === 1) {
      if (val) {
        return checkNewWeight(val[0]);
      } else {
        return /* None */0;
      }
    }
    
  } else {
    return /* None */0;
  }
}

exports.jsonParse = jsonParse;
exports.decodedTokenData = decodedTokenData;
exports.setAccessTokenandExpiry = setAccessTokenandExpiry;
exports.checkDate = checkDate;
exports.localStorageSupported = localStorageSupported;
exports.checkIfLoggedIn = checkIfLoggedIn;
exports.storeLoc = storeLoc;
exports.clearLoc = clearLoc;
exports.checkLoc = checkLoc;
exports.readLocFromLs = readLocFromLs;
exports.checkForLastRouteFromLs = checkForLastRouteFromLs;
exports.calculateProgramDay = calculateProgramDay;
exports.weekOfDay = weekOfDay;
exports.weekDay = weekDay;
exports.fullDay = fullDay;
exports.fullDayMax28 = fullDayMax28;
exports.getWeight = getWeight;
exports.getDuration = getDuration;
exports.getCals = getCals;
exports.getCalsLevel = getCalsLevel;
exports.store14 = store14;
exports.clear14 = clear14;
exports.check14 = check14;
exports.show14 = show14;
exports.store24 = store24;
exports.clear24 = clear24;
exports.check24 = check24;
exports.show24 = show24;
exports.storeWeightDiff = storeWeightDiff;
exports.clearNewWeight = clearNewWeight;
exports.checkNewWeight = checkNewWeight;
exports.getWeightDiff = getWeightDiff;
/* Network Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/storage.re
// module id = 14
// module chunks = 0